import { createRouter, createWebHashHistory } from "vue-router";
import HomeView from "../views/HomeView.vue";
import MainPageLogin from "@/contents/landing/main-page-login.vue";
const routes = [
  {
    path: "/settings/add-user",
    name: "addUser",
    component: function () {
      return import("../views/AddUserPage.vue");
    },
    meta: { requiresAuth: true, requiresKyc: true }
  },
  {
    path: "/settings/edit-user/:wallet",
    name: "editUser",
    component: function () {
      return import("../views/AddUserPage.vue");
    },
    meta: { requiresAuth: true, requiresKyc: true }

  },
  {
    path: "/",
    name: "index",
    component: function () {
      return import("../views/IndexView.vue");
    },
  },
  {
    path: "/home",
    name: "home",
    component: MainPageLogin,
    // component: HomeView,
  },
  {
    path: "/kyc-application",
    name: "kyc-application",
    component: function () {
      return import("../views/kyc-application.vue");
    },
    meta: { requiresAuth: true, roles: ["ISSUER"], requiresKyc: false }
  },
  {
    path: "/kyc-status",
    name: "kyc-status",
    component: function () {
      return import("../views/kycStatusPage.vue");
    },
    meta: { requiresAuth: true, roles: ["ISSUER"], requiresKyc: false }
  },
  {
    path: "/certificate",
    name: "certificate-page",
    component: function () {
      return import("../views/CertificatePage.vue");
    },
    meta: { requiresAuth: true, requiresKyc: true }
  },
  {
    path: "/settings",
    name: "settings-page",
    component: function () {
      return import("../views/SettingsPage.vue");
    },
    meta: { requiresAuth: true, requiresKyc: true }
  },
  {
    path: "/template",
    name: "template-page",
    component: function () {
      return import("../views/TemplateList.vue");
    },
    meta: { requiresAuth: true, requiresKyc: true }
  },
  {
    path: "/create-template",
    name: "create-template-page",
    component: function () {
      return import("../views/CreateTemplate.vue");
    },
    meta: { requiresAuth: true, requiresKyc: true }
  },
  {
    path: "/audit-log",
    name: "audit-log-page",
    component: function () {
      return import("../views/AuditLogPage.vue");
    },
    meta: { requiresAuth: true, requiresKyc: true }
  },
  {
    path: "/vc-design",
    name: "vc-design-page",
    component: function () {
      return import("../views/VcDesignPage.vue");
    },
    meta: { requiresAuth: true, requiresKyc: true }
  },
  {
    path: "/vc-design/:templateId",
    name: "vc-design-page-edit",
    component: function () {
      return import("../views/VcDesignPage.vue");
    },
  },
  {
    path: "/vc-design/:templateId/:designId",
    name: "vc-design-page-edits",
    component: function () {
      return import("../views/VcDesignPage.vue");
    },
  },
  {
    path: "/issuer/application-list",
    name: "issuer-application-list",
    component: function () {
      return import("../views/KycListApplication.vue");
    },
    meta: { requiresAuth: true }
  },
  {
    path: "/issuer/vc-design-review-list",
    name: "issuer-vc-design-review-list",
    component: function () {
      return import("../views/VcDesignListManagement.vue");
    },
    meta: { requiresAuth: true }
  },
  {
    path: "/issuer/management",
    name: "issuer-management",
    component: function () {
      return import("../views/IssuerManagement.vue");
    },
    meta: { requiresAuth: true }
  },
  {
    path: "/issuer/kyc-application-details/:address",
    name: "kyc-application-detail",
    component: function () {
      return import("../views/KycApplicationDetails.vue");
    },
  },
  {
    path: "/issuer/vc-design-review-details/:templateId",
    name: "vc-design-review-details",
    component: function () {
      return import("../views/VcDesignDetails.vue");
    },
  },
  {
    path: "/issuer/template-details/:templateId",
    name: "template-details",
    component: function () {
      return import("../views/TemplateDetails.vue");
    },
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/"
  },
  {
    path: "/issuer/template-attribute-details/:templateId",
    name: "template-attribute-details",
    component: function () {
      return import("../views/TemplateAttributeDetails.vue");
    },
    meta: { requiresAuth: true }
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  const user = {
    role: sessionStorage.getItem("userRole"),
    kyc: sessionStorage.getItem("kyc"),
    kycApproved: sessionStorage.getItem("kyc") === "ACTIVE",
    token: sessionStorage.getItem("accessToken"),
  };

  if (to.meta.requiresAuth) {
    if (!user.token) {
      return next("/");
    }

    // --- ADMIN bypass KYC and go to issuer list ---
    if (user.role === "ADMIN") {
      if (to.path === "/") {
        return next("/issuer/application-list");
      }
      return next();
    }

    if (to.meta.requiresKyc) {
      // ISSUER must have their own KYC approved
      if (user.role === "ISSUER") {

        if (user.kyc === null || user.kyc === "null") {
          return next("/kyc-application");
        }
        if (!user.kycApproved) {
          return next("/kyc-status");
        }

      }

      // MAKER → skip KYC if parent issuer approved
      if (user.role === "MAKER") {
        if (!user.kycApproved) {
          return next("/kyc-status"); // fallback if somehow issuer not approved
        }
      }
    }
  }

  if (to.path === "/" && user.token) {
    if (user.role === "ISSUER" || user.role === "MAKER") {
      if (user.kyc === "ACTIVE" && user.kycApproved) {
        return next("/certificate");
      }
      if ((user.kyc == null || user.kyc === "null") && !user.kycApproved) {
        return next("/kyc-application");
      }
      if (["PENDING", "REJECTED", "REVOKED"].includes(user.kyc) && !user.kycApproved) {
        return next("/kyc-status");
      }
    }

    if (user.role === "ADMIN") {
      return next("/issuer/application-list");
    }

  }

  next();
});




export default router;
